export default __webpack_public_path__ + "media/images/theme/m_logo_dark-a033e56c069ba0823d7f2af6049d0155.png";